import PropTypes from 'prop-types';
import React from 'react';
import { ThemeProvider } from 'react-css-themr';
import { ResourceDetailsCardElement } from 'components/ResourceCardElements';
import PurchaseOrders from 'components/PurchaseOrders';
import styles from '../refigure.scss';
import { formatTelephone } from '../../../../utils';

const theme = {
  ResourceDetailsCE: styles,
};

const RefigureHeader = ({ phaseDetails }) =>
  <ThemeProvider theme={theme}>
    <div className={styles.ResourceDetails}>
      <h5 className={styles.RefigureHeader}>Refigure Request:</h5>
      <ResourceDetailsCardElement title="customer name:" value={phaseDetails.customer_name} />
      <ResourceDetailsCardElement title="phone number:" value={formatTelephone(phaseDetails.phone_number)} />
      <ResourceDetailsCardElement title="p.o. #:" >
        <PurchaseOrders
          className={styles.resourceCardElementValue}
          purchaseOrders={phaseDetails.purchase_orders}
        />
      </ResourceDetailsCardElement>
      <ResourceDetailsCardElement title="Store #:" value={phaseDetails.store_number} />
    </div>
  </ThemeProvider>;

RefigureHeader.propTypes = {
  phaseDetails: PropTypes.object,
};

export default RefigureHeader;



// WEBPACK FOOTER //
// ./client/app/screens/refigure/form/components/refigureHeader.jsx